import { render, staticRenderFns } from "./one_stop_trading_legalNotices.vue?vue&type=template&id=2588af5c&scoped=true&"
import script from "./one_stop_trading_legalNotices.vue?vue&type=script&lang=js&"
export * from "./one_stop_trading_legalNotices.vue?vue&type=script&lang=js&"
import style0 from "./one_stop_trading_legalNotices.vue?vue&type=style&index=0&id=2588af5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588af5c",
  null
  
)

export default component.exports